// base rc-virtual-list 3.4.2
import List from './List';
export default List;
